function init() {
  var announcementBar = document.querySelector('.announcement_bar');
  var rotationIntervalMS = parseInt(announcementBar.dataset.rotationInterval) * 1000;
  var totalItems = announcementBar.querySelectorAll('[data-rotation-order]').length;

  if (totalItems > 1) {
    setInterval(function() {
      var activeItem = announcementBar.querySelector('[data-rotation-order="1"]');
      var nextItem = activeItem.nextElementSibling || activeItem.parentElement.firstElementChild;
  
      activeItem.dataset.rotationOrder = 0;
      if (nextItem) {
        updateOrder(nextItem);
      } else {
        updateOrder(nextItem.parentElement.firstElementChild);
      }
    }, rotationIntervalMS);
  }
}

function updateOrder(el) {
  if (el.dataset.rotationOrder == 0) {
    el.dataset.rotationOrder = el.parentElement.children.length;
  } else {
    var order = parseInt(el.dataset.rotationOrder);
    el.dataset.rotationOrder = order - 1;
    if (el.nextElementSibling) {
      updateOrder(el.nextElementSibling);
    } else {
      var next = el.parentElement.firstElementChild;
      updateOrder(next);
    }
  }

  animate(el);
}

function animate (el) {
  switch(el.dataset.rotationOrder) {
    case '1': 
      el.style.opacity = '1';
    break;
    default:
      el.style.opacity = '0';
      break;
  }
  el.style.order = el.dataset.rotationOrder;
}

init();